import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../../../components/ui/input';

interface CheckViewFiltersProps {
    dateStart: string;
    setDateStart: (d: string) => void;
    dateEnd: string;
    setDateEnd: (d: string) => void;
    statusFilter: string;
    setStatusFilter: (s: string) => void;
    channelFilter: string;
    setChannelFilter: (c: string) => void;
    search: string;
    setSearch: (s: string) => void;
    channelOptions: string[];
}

export const CheckViewFilters: React.FC<CheckViewFiltersProps> = ({
    dateStart, setDateStart,
    dateEnd, setDateEnd,
    statusFilter, setStatusFilter,
    channelFilter, setChannelFilter,
    search, setSearch,
    channelOptions
}) => {
    const { t } = useTranslation('common');

    const selectClass = "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50";

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6 p-4 bg-gray-50 rounded-lg border border-gray-100">
            {/* Date Start */}
            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-gray-700">{t('checkView.management.fromDate')}</label>
                <Input
                    type="date"
                    value={dateStart}
                    onChange={(e) => setDateStart(e.target.value)}
                    className="bg-white"
                />
            </div>

            {/* Date End */}
            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-gray-700">{t('checkView.management.toDate')}</label>
                <Input
                    type="date"
                    value={dateEnd}
                    onChange={(e) => setDateEnd(e.target.value)}
                    className="bg-white"
                />
            </div>

            {/* Status */}
            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-gray-700">{t('checkView.management.status')}</label>
                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className={`${selectClass} bg-white`}
                >
                    <option value="">{t('checkView.management.allStatus')}</option>
                    <option value="active">{t('checkView.management.active')}</option>
                    <option value="inactive">{t('checkView.management.inactive')}</option>
                </select>
            </div>

            {/* Channel */}
            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-gray-700">{t('checkView.management.channel')}</label>
                <select
                    value={channelFilter}
                    onChange={(e) => setChannelFilter(e.target.value)}
                    className={`${selectClass} bg-white`}
                >
                    <option value="">{t('checkView.management.allChannels')}</option>
                    {channelOptions.map(ch => (
                        <option key={ch} value={ch}>{ch}</option>
                    ))}
                </select>
            </div>

            {/* Search */}
            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-gray-700">{t('checkView.management.search')}</label>
                <Input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder={t('checkView.management.searchPlaceholder')}
                    className="bg-white"
                />
            </div>
        </div>
    );
};
